
    var riot = require('riot')
    
riot.tag2('loginbar', '<div class="search"> <form method="get" action="/system/search-results/"> <div class="input-group"> <input placeholder="Search NAFEMS" name="search" value="{opts.searchterm}" class="form-control"> <div class="input-group-btn"> <button type="submit" class="btn btn-primary"><span class="fa fa-search"></span></button> </div> </div> </form> </div> <div class="btn-toolbar"> <div class="btn-group basket-group"> <div onclick="{showcurrency}" tabindex="0" role="button" class="btn btn-blue currency {currencyclass}">{currencies[currency]} <ul class="dropdown-menu"> <li><a href="#" onclick="{setCurrency.bind(this,\'GBP\')}">£ (GBP)</a></li> <li><a href="#" onclick="{setCurrency.bind(this,\'USD\')}">$ (USD)</a></li> <li><a href="#" onclick="{setCurrency.bind(this,\'EUR\')}">€ (EUR)</a></li> </ul> </div> <button riot-tag="popup-basket" checkout-url="/checkout/" currency="{currency}" onclose="{basketclose}" showcurrency="true" class="btn btn-primary basket">{parent.total || ⁗0.00⁗} </button> </div><a href="/system/sign_up/" if="{!userid}" class="btn btn-success signup">Register for Free</a> <button onclick="{showlogin}" if="{!userid}" class="btn btn-primary signin"> Sign In </button><a href="/mynafems/" if="{userid}" class="btn btn-blue account"> My NAFEMS </a><a if="{userid}" class="btn btn-blue credits">{credits} Credits</a> <div if="{opts.due &amp;&amp; opts.membertype &amp;&amp; opts.soon &gt; 28}" class="memberinfo"><span class="orgname">{shorten(opts.name,47)}. </span><span class="renewtxt"> Renewal <dateformat date="{new Date(opts.due || null)}" format="dd MMM yyyy"></dateformat></span></div><a if="{opts.due &amp;&amp; opts.membertype &amp;&amp; opts.soon &lt;= 28}" href="/mynafems/renewal/" class="memberinfo renew"><span class="orgname">{shorten(opts.name,47)}. </span><span class="renewtxt"> Renewal <dateformat date="{new Date(opts.due || null)}" format="dd MMM \'yy"></dateformat></span></a> <button onclick="{logout}" if="{userid}" class="btn btn-blue logout"> Logout </button> </div> <modal name="loginmodal" title="NAFEMS Sign in" onclose="{true}" closetext="Cancel" onsave="{login}" savetext="Login"> <form onsubmit="{parent.login}" class="form-horizontal"> <forminput name="email" label="Email" onupdate="{parent.inputupdate}" isrequired type="email"></forminput> <forminput type="password" name="password" label="Password" onupdate="{parent.inputupdate}" isrequired></forminput> <div class="pull-right"> <a href="#" onclick="{parent.showForgotPassword}">Forgot Password </a></div> <input type="submit" value="" style="opacity:0"> </form> <div if="{parent.error}" class="alert alert-danger">{parent.error}</div><a href="/system/sign_up/" class="btn btn-default modalsignup">Not got an account?</a> </modal> <modal name="accontmodal" title="Your Account" onclose="{true}" closetext="Cancel" onsave="{login}" savetext="Save"> <p>Your Account Details</p> </modal> <forgot-password-modal></forgot-password-modal>', 'a.modalsignup { position: absolute; bottom: -50px; left: 15px; } .loginbar { display: block; } .loginbar .currency { width: 40px; } .loginbar .currency .dropdown-menu { display: block; min-width: auto; } .loginbar .currency .dropdown-menu li > a { min-width: auto; padding: 10px 14px; } .loginbar .currency.show .dropdown-menu { max-height: 125px; } .loginbar .btn.basket { text-align: left; padding-right: 30px; position: relative; } .loginbar .btn.basket:after { position: absolute; content: "\\f291"; right: 8px; top: 8px; font: normal normal normal 18px/1 FontAwesome; } @media (min-width: 991px) { .loginbar { position: absolute; top: 10px; z-index: 21; right: 50%; } .loginbar .btn-toolbar { float: left; } .loginbar .btn.basket, .loginbar .btn.signin, .loginbar .btn.signup { min-width: 120px; } .loginbar .btn { font-weight: bold; } .loginbar .search { width: 250px; margin-right: 5px; float: left; } } @media (min-width: 991px) { .loginbar { margin-right: -475px; } } @media (min-width: 1199px) { .loginbar { margin-right: -575px; } } @media (max-width: 991px) { .loginbar { max-width: 720px; margin: 0 auto; padding: 5px; background: #eee; } .loginbar .currency .dropdown-menu { max-height: 0; padding: 0; border: 0; overflow: hidden; } .loginbar .btn-toolbar { margin-left: 0; } .loginbar .search { margin: 5px; } .loginbar .basket-group { width: calc(100% - 5px); } .loginbar .basket-group .currency { width: 40px; } .loginbar .basket-group .basket { width: calc(100% - 40px); } .loginbar .btn.signin, .loginbar .btn.account, .loginbar .btn.logout, .loginbar .btn.credits, .loginbar .btn.signup { width: calc(50% - 5px); margin: 5px 0 5px 5px; } }', '', function(opts) {
var tagSelector, xhr;

xhr = require("../libs/xhr.coffee");

tagSelector = require('riot-kit/utils/tagSelector.coffee');

if (opts.csrf) {
  window.csrf = opts.csrf;
}

this.credentials = {};

this.user = null;

this.currencyclass = "";

this.currency = opts.currency || "GBP";

this.currencies = {
  "GBP": "£",
  "USD": "$",
  "EUR": "€"
};

this.on("mount", function() {
  this.userid = +opts.userid;
  if (this.userid) {
    this.getCredits();
  }
  return this.getBasket();
});

this.basketclose = (function(_this) {
  return function() {
    _this.basket = tagSelector('popup-basket');
    if (_this.basket._tag.currency && _this.basket._tag.currency !== _this.currency) {
      _this.currency = _this.basket._tag.currency;
    }
    return _this.getBasket();
  };
})(this);

this.getBasket = (function(_this) {
  return function(cback) {
    console.log("getBasket", _this.currency);
    return xhr("GET", "/duocms/api/basket?currency=" + _this.currency, null, function(res) {
      var ref, ref1;
      _this.total = ((ref = res.body.data) != null ? (ref1 = ref.total) != null ? ref1.toFixed(2) : void 0 : void 0) || "0.00";
      if (cback) {
        cback();
      }
      return _this.update();
    });
  };
})(this);

this.showForgotPassword = (function(_this) {
  return function(e) {
    e.preventDefault();
    _this.tags['forgot-password-modal'].trigger('show');
    return _this.tags['forgot-password-modal'].forgotpassword.user.email = _this.credentials.email;
  };
})(this);

this.getCredits = (function(_this) {
  return function() {
    var credits, data;
    credits = window.sessionStorage.getItem("credits");
    if (credits) {
      data = JSON.parse(credits);
      if (new Date().getTime() - data.when < (60 * 1000)) {
        _this.update({
          credits: data.credits,
          notify_credits: data.notify_credits
        });
        return;
      }
    }
    return xhr("GET", "/duocms/api/team/credits", null, function(res) {
      if (res.body.data) {
        data = JSON.stringify({
          when: new Date().getTime(),
          credits: res.body.data.credits,
          notify_credits: res.body.data.notify_credits,
          orghash: res.body.data.orghash
        });
        window.sessionStorage.setItem("credits", data);
        return _this.update({
          credits: res.body.data.credits,
          notify_credits: res.body.data.notify_credits
        });
      }
    });
  };
})(this);

this.setCurrency = (function(_this) {
  return function(curr) {
    if (_this.currency !== curr) {
      _this.currency = curr;
      return _this.getBasket(function() {
        return window.location.reload();
      });
    }
  };
})(this);

this.updateCheckout = (function(_this) {
  return function() {
    var ref, ref1, ref2;
    if (((ref = document.querySelector("checkout")) != null ? (ref1 = ref._tag) != null ? (ref2 = ref1.tags) != null ? ref2.basket : void 0 : void 0 : void 0) == null) {
      return;
    }
    document.querySelector("checkout").setAttribute("currency", _this.currency);
    document.querySelector("checkout")._tag.transaction.postage = null;
    document.querySelector("checkout")._tag.showConfirm = false;
    return document.querySelector("checkout")._tag.tags.basket.updateBasket();
  };
})(this);

this.updateBuyButtons = (function(_this) {
  return function() {
    if (document.querySelectorAll("buy").length > 0) {
      return window.location.reload();
    }
  };
})(this);

this.showlogin = (function(_this) {
  return function() {
    window.sessionStorage.removeItem("credits");
    return _this.tags.loginmodal.show();
  };
})(this);

this.inputupdate = (function(_this) {
  return function(val) {
    return _this.credentials[val.name] = val.value;
  };
})(this);

this.showcurrency = (function(_this) {
  return function() {
    if (_this.currencyclass === "") {
      _this.currencyclass = "show";
      setTimeout((function() {
        return document.addEventListener("click", _this.hidecurrency);
      }), 500);
    }
    return _this.update();
  };
})(this);

this.hidecurrency = (function(_this) {
  return function() {
    _this.currencyclass = "";
    document.removeEventListener("click", _this.hidecurrency);
    return _this.update();
  };
})(this);

this.login = (function(_this) {
  return function(login) {
    if (_this.credentials.email.match(/@/) && _this.credentials.password.length > 6) {
      return xhr("POST", "/duocms/api/login", _this.credentials, function(res) {
        var loginpath, ref, ref1;
        if (res.status >= 400) {
          if ((ref = res.body) != null ? (ref1 = ref.message) != null ? ref1.match(/CSRF/) : void 0 : void 0) {
            _this.updateCSRF();
            _this.login();
            return;
          }
          _this.update({
            error: res.body.message
          });
          return setTimeout((function() {
            return _this.update({
              error: null
            });
          }), 3000);
        } else if (res.status === 200) {
          _this.tags.loginmodal.hide();
          _this.user = res.body;
          _this.userid = res.body.data.id;
          loginpath = window.sessionStorage.getItem("loginpath");
          if (loginpath) {
            window.sessionStorage.removeItem("loginpath");
            window.location.pathname = loginpath;
          } else if (_this.loggedin) {
            _this.loggedin();
          } else {
            window.location.reload();
          }
          return _this.update();
        }
      });
    }
  };
})(this);

this.logout = (function(_this) {
  return function() {
    return xhr("GET", "/duocms/api/logout", null, function(res) {
      _this.user = null;
      _this.userid = null;
      _this.update();
      window.location.pathname = '/';
      return null;
    });
  };
})(this);

this.showaccount = (function(_this) {
  return function() {
    return _this.tags.accontmodal.show();
  };
})(this);

this.updateCSRF = function() {
  var csrfcookie;
  csrfcookie = document.cookie.match(/_csrf=([^ ;]+)/);
  if (csrfcookie && csrfcookie.length > 0) {
    console.log(csrfcookie[1]);
    return window.csrf = csrfcookie[1];
  }
};

this.shorten = (function(_this) {
  return function(txt, len) {
    var trimTxt;
    trimTxt = txt.substr(0, len);
    if (txt.length > len) {
      trimTxt += "…";
    }
    return trimTxt;
  };
})(this);
});
    
  